import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Shipment, ShipmentCheckpoint } from "@/domain";
interface ShipmentState {
  shipments: Shipment[];
  checkpoints: ShipmentCheckpoint[];
  add: (shipment: Shipment, checkpoints: ShipmentCheckpoint[]) => void;
}
export const useShipmentStore = create<ShipmentState>()(
  persist(
    (set) => ({
      shipments: [],
      checkpoints: [],
      add: (shipment, checkpoints) =>
        set((s) => ({
          shipments: [shipment, ...s.shipments],
          checkpoints: [...s.checkpoints, ...checkpoints],
        })),
    }),
    { name: "latisent-shipments-v2" },
  ),
);
